import {
	Component,
	OnInit,
	ViewChild,
} from '@angular/core';

import { LoaderComponent } from 'ib/internetbank-core/ib-components/loader/loader.component';

import { RouteAction } from '../../../shared/notifications/models/route-action';
import { Insurance, InsuranceIdByTypes } from '../insurance';
import { InsuranceSectionService } from '../insurance-section.service';

@Component({
	selector: 'app-insurance-suggestions',
	templateUrl: './insurance-suggestions.component.html',
	styleUrls: ['./insurance-suggestions.component.less'],
	standalone: false,
})
export class InsuranceSuggestionsComponent implements OnInit {

	@ViewChild(LoaderComponent, { static: true })
	public loader: LoaderComponent;

	public suggestions: Array<Insurance & { routeAction: RouteAction }>;

	constructor(
		private insuranceSectionService: InsuranceSectionService,
	) {
	}

	public ngOnInit(): void {
		this.insuranceSectionService.getInsuranceListForShowcase()
			.subscribe((insurances: Array<Insurance>) => {
				this.suggestions = insurances.map((item: Insurance) => {
					const action: RouteAction = new RouteAction();

					switch (item.insuranceId) {
						case InsuranceIdByTypes.TRAVEL:
							action.route = ['create'];
							action.queryParams = { frameUrl: item.link || undefined }
							break;

						case InsuranceIdByTypes.SPORT:
							action.route = [
								'create',
								InsuranceIdByTypes.SPORT,
							];
							break;
					}

					return {
						...item,
						routeAction: action,
					}
				});
				this.loader.hide();
			});
	}

}
